<template>
  <div>
    <el-dialog
      :title="isType == 1 ? $t('lang.修改用户名称') : $t('lang.修改密码')"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <el-form label-width="120px" v-if="isType == 1">
        <el-form-item :label="$t('lang.名称')">
          <el-input
            v-model="nickName"
            :placeholder="$t('lang.请输入名称')"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form
        :label-width="$i18n.locale == 'zh-CN' ? '130px' : '170px'"
        ref="ruleFormRef"
        :rules="rules"
        :model="passwordForm"
        v-else
      >
        <div>
          <el-form-item :label="$t('lang.旧密码')" prop="password">
            <el-input
              type="password"
              :placeholder="$t('lang.请输入旧密码')"
              v-model="passwordForm.password"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.新密码')" prop="newPassword">
            <el-input
              type="password"
              :placeholder="$t('lang.请输入新密码')"
              v-model="passwordForm.newPassword"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.确认密码')" prop="confirmPassword">
            <el-input
              type="password"
              :placeholder="$t('lang.请再次输入新密码')"
              v-model="passwordForm.confirmPassword"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('lang.二级密码')"
            prop="securityPwd"
            v-if="isSetPwd2"
          >
            <el-input
              type="password"
              :placeholder="$t('lang.请输入二级密码')"
              v-model="passwordForm.securityPwd"
              show-password
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t("lang.取消") }}</el-button>
        <el-button type="primary" @click="onClickSubmitted">{{
          $t("lang.确定")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    isSetPwd2: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    var password = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("lang.请输入旧密码")));
      } else {
        callback();
      }
    };
    var newPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("lang.请输入新密码")));
      } else if (!/^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z\d]{8,20}$/.test(value)) {
        callback(new Error(this.$t("lang.密码输入不符合规则")));
      } else {
        callback();
      }
    };
    var confirmPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("lang.请再次输入新密码")));
      } else if (!/^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z\d]{8,20}$/.test(value)) {
        callback(new Error(this.$t("lang.密码输入不符合规则")));
      } else if (this.passwordForm.newPassword != value) {
        callback(new Error(this.$t("lang.两次密码输入不一致")));
      } else {
        callback();
      }
    };
    var securityPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("lang.请输入二级密码")));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      nickName: "",
      passwordForm: {
        password: "",
        newPassword: "",
        confirmPassword: "",
        securityPwd: "",
      },
      isType: 1,
      rules: {
        password: [{ validator: password, trigger: "blur" }],
        newPassword: [{ validator: newPassword, trigger: "blur" }],
        confirmPassword: [{ validator: confirmPassword, trigger: "blur" }],
        securityPwd: [{ validator: securityPwd, trigger: "blur" }],
      },
    };
  },
  methods: {
    ...mapActions({
      userChangeNickname: "ZD_UserChangeNickname",
      userChangeThePassword: "ZD_UserChangeThePassword",
    }),
    handleClose() {
      this.dialogVisible = false;
      if (this.isType !== 2) return;
      this.$refs.ruleFormRef.resetFields();
    },
    async onClickSubmitted() {
      if (this.isType == 1) {
        let reg = /(-|#|;|'|''|\\)|[\x00-\x1F]/gi;
        if (reg.test(this.nickName))
          return this.$message({
            message: this.$t("lang.不能有特殊字符"),
            type: "warning",
          });
        let res = await this.userChangeNickname({
          value: {
            nickName: this.nickName.trim(),
          },
        });
        if (res.success !== 1) return;
        this.$message({
          message: this.$t("lang.修改成功"),
          type: "success",
        });
        this.$parent.nickName = this.nickName;
        this.$bus.$emit("userNameModify", this.nickName);
        this.dialogVisible = false;
      } else {
        try {
          await this.$refs.ruleFormRef.validate();
          let tempReq = {
            password: this.passwordForm.password,
            newPassword: this.passwordForm.newPassword,
          };
          if (this.isSetPwd2)
            tempReq.securityPwd = this.passwordForm.securityPwd;
          let res = await this.userChangeThePassword({
            value: tempReq,
          });
          if (res.success !== 1) return;
          this.$message({
            message: this.$t("lang.修改成功"),
            type: "success",
          });
          this.handleClose();
        } catch {}
      }
    },
  },
};
</script>

<style scoped lang='less'>
/deep/ .el-dialog {
  width: 576px;
}
/deep/ .el-dialog .el-input {
  width: 300px;
}
/deep/.el-dialog__body {
  padding-bottom: 10px;
  padding-left: 40px;
}
</style>